import { Box, styled } from '@mui/system';
import { Alert, Typography } from '@mui/material';

export const StyledAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  paddingTop: theme.spacing(1)
}));

export const KeyDisplayContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(2),
  fontFamily: 'monospace',
  wordBreak: 'break-all'
}));

export const KeyText = styled(Typography)(({ theme }) => ({
  flexGrow: 1,
  fontFamily: 'monospace',
  marginRight: theme.spacing(1)
}));
